import { ReactNode, useRef } from "react"
import { useAutoFitEscala } from "./hooks/useAutoFitEscala"

interface AvisoFijoProps {
    // Identifica el contenido: al cambiar se vuelve a calcular el tamaño.
    id: string
    children: ReactNode
}

// Mensaje fijo (sin avisos configurables) que reduce su texto solo si no cabe en el slide.
export function AvisoFijo({ id, children }: AvisoFijoProps) {
    const containerRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)

    useAutoFitEscala({ containerRef, contentRef, id })

    return (
        <div className="disp__message-slide">
            <div className="disp__aviso-fijo" ref={containerRef}>
                <div className="disp__aviso-fijo__content" ref={contentRef}>
                    {children}
                </div>
            </div>
        </div>
    )
}
